import { useLocation, useNavigate } from "react-router-dom";
//#region redux
//#endregion
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import { IconDefinitionConstants, RouteConstants } from "utils/constants";

function useCreateCustomerInvoiceAction(selfInvoiceId: string): MoreActionMenuItemType {
  const location = useLocation();
  const navigate = useNavigate();

  const createCustomerInvoiceAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SendAsCustomerInvoice),
    icon: IconDefinitionConstants.WSend,
    onClickHandler: async () => {
      navigate(
        UrlHelper.formatPath(
          `/Invoice/Create?${RouteConstants.QueryParamStrings.SelfInvoiceTemplate}=${selfInvoiceId}`
        ),
        {
          state: { background: location },
        }
      );
    },
  };

  return createCustomerInvoiceAction;
}

export default useCreateCustomerInvoiceAction;
